<template>
  <div class="site-wrapper">
      <Stage></Stage>
      <GridImg></GridImg>
      <ThreeHeadlines></ThreeHeadlines>
      <TeaserVideo></TeaserVideo>
      <AppStoreCta></AppStoreCta>
      <Slider></Slider>
      <Footer></Footer>


  </div>
</template>

<script>
  import Stage from './modules/Stage/Stage';
  import ThreeHeadlines from './modules/ThreeHeadlines/ThreeHeadlines';
  import TeaserVideo from './modules/TeaserVideo/TeaserVideo';
  import AppStoreCta from './modules/AppStoreCta/AppStoreCta';
  import Slider from './modules/Slider/Slider';
  import GridImg from './modules/GridImg/GridImg';
  import Footer from './modules/Footer/Footer';

export default {
    name: 'HelloWorld',
    props: {
        msg: String
    },
    components: {
        Stage,
        GridImg,
        ThreeHeadlines,
        TeaserVideo,
        AppStoreCta,
        Slider,
        Footer,

    }
}
</script>

<style>


    body {
        margin: 0;
        padding: 0;
        font-family: dkms2;
        max-width: 1920px;
        margin: 0 auto;
    }

    .site-wrapper {
        width: 100%;
    }

    @font-face {
        font-family: dkms1;
        src: url(../assets/fonts/721323/dkms.woff);
    }

    @font-face {
        font-family: dkms2;
        src: url(../assets/fonts/1475508/dkms2.woff);
    }
</style>
